/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import {
  Button,
  Typography,
  Tooltip,
  Card,
  Space,
  Divider,
  Alert,
  Select,
  Col,
  Row,
} from 'antd';
import { withConfigContext } from '../../../../../../../../../components/ConfigContext';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import { handleApiError } from '../../../../../../../../../services/utils/errorHandler';
import { isAuthorized } from '../../../../../../../../../services/utils/authorizationHandler';
import HtmlComments from '../../../../../../../../../components/ReactHtmlComments/HtmlComments';
import AddRole from '../../../../../../Roles/components/RolesTable/components/AddRole';
import { Link } from 'react-router-dom';
import styles from '../styles.module.css';
import { PlusOutlined } from '@ant-design/icons';

const { Paragraph } = Typography;

class AttachingRoles extends React.Component {
  constructor(props) {
    super(props);
    this.config = this.props.context;
    this.state = {
      editModalVisible: false,
      shareModalVisible: false,
      groupDataObject: {},
      rolesData: [],
      shareRolesData: [],
      sharedRolesData: [],
      loading: false,
      popoverVisible: false,
    };
  }

  componentDidMount() {
    this.fetchRoles();
  }

  fetchUserRoles = (params = {}) => {
    const config = this.props.context;
    const { t } = this.props;
    const apiUrl =
      window.location.origin +
      config.serverConfig.invoker.uri +
      config.serverConfig.invoker.deviceMgt +
      '/roles';

    // send request to the invokerss
    axios
      .get(apiUrl)
      .then(res => {
        if (res.status === 200) {
          this.setState({
            rolesData: res.data.data.roles,
          });
        }
      })
      .catch(error => {
        handleApiError(
          error,
          t('api_loadError', { label: t('home_menu_roles') }),
          t,
        );
      });
  };

  onConfirmShareGroup = data => {
    this.props.onConfirmShareGroup(data);
  };

  fetchRoles = () => {
    if (isAuthorized(this.config.scopes, ['perm:roles:view'])) {
      this.fetchUserRoles();
    }
  };

  handleRolesDropdownChange = value => {
    this.onConfirmShareGroup(value);
    this.setState({
      shareRolesData: value,
    });
  };

  onFinish = values => {};
  onFinishFailed = errorInfo => {};

  render() {
    const { t } = this.props;
    let item = this.state.rolesData.map(data => (
      <Select.Option value={data} key={data}>
        {data}
      </Select.Option>
    ));
    return (
      <div>
        <Card>
          <div>
            <HtmlComments
              permission={
                '/permission/admin/device-mgt/groups/share,\n' +
                '/permission/admin/device-mgt/groups/update,\n' +
                '/permission/admin/device-mgt/groups/remove'
              }
            />
            {isAuthorized(this.config.scopes, ['perm:groups:share']) && (
              <span>
                <HtmlComments
                  permission={
                    '/permission/admin/device-mgt/roles/view OR\n' +
                    '/permission/admin/device-mgt/groups/roles/view'
                  }
                />
              </span>
            )}
          </div>
          <div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ marginRight: '10px', marginTop: '12px' }}>
                  {t('form_searchUserRoles')}:{' '}
                </p>
                <Select
                  mode="multiple"
                  value={this.state.shareRolesData}
                  style={{
                    width: '45%',
                    marginLeft: '10px',
                    marginRight: '10px',
                  }}
                  onChange={this.handleRolesDropdownChange}
                >
                  {item}
                </Select>
                <Tooltip title="Add new role">
                  <Link
                    key="add-new-role"
                    to={`/${this.config.appName}/groups/add-group?add-new-role=true`}
                  >
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={this.handleAddNewRole}
                    />
                  </Link>
                </Tooltip>
                <div style={{ background: '#f0f2f5' }}>
                  <AddRole fetchRoles={this.fetchUserRoles} />
                </div>
              </div>

              {!isAuthorized(this.config.scopes, [
                'perm:roles:create-combined-role',
              ]) ||
                (!isAuthorized(this.config.scopes, [
                  'perm:roles:view',
                  'perm:groups:roles',
                ]) && (
                  <div>
                    <HtmlComments
                      permission={
                        '/permission/admin/device-mgt/roles/manage OR\n' +
                        '/permission/admin/device-mgt/roles/view\n' +
                        '/permission/admin/device-mgt/groups/roles/view'
                      }
                    />
                    <Alert
                      message={t('noPerm_someFields')}
                      banner
                      style={{ marginBottom: 15 }}
                    />
                  </div>
                ))}
            </div>
          </div>
          <br />
          <Row>
            <Col lg={{ span: 1, offset: 18 }}>
              <div className={styles.buttons}>
                <Space>
                  <Button htmlType="submit" onClick={this.props.setPrevStep}>
                    {t('label_back')}
                  </Button>

                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={this.props.setNextStep}
                  >
                    {t('label_continue')}
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>

          <br />
          <br />
          <Divider />
          <Typography>
            <Paragraph>{t('label_group_sharing_description')}</Paragraph>
          </Typography>
        </Card>
      </div>
    );
  }
}

export default withConfigContext(withTranslation()(AttachingRoles));
